import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class SignupOrgService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }

  getCategories() {
    const token = this.cookieService.get('accessToken');
    return this.http.post('/api/org/categories', `access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  update(data) {
    const token = this.cookieService.get('accessToken');
    const p = { ...data };
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`
    ];
    return this.http.post('/api/org/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addInfo(data) {
    const token = this.cookieService.get('accessToken');
    const p = { ...data };
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`
    ];
    return this.http.post('/api/org/addInfo', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  verificate(data) {
    const token = this.cookieService.get('accessToken');
    const p = { ...data };
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`
    ];
    return this.http.post('/api/org/verification', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  setPlan(planType, invoiceAmount) {
    const token = this.cookieService.get('accessToken');
    const p = { planType, invoiceAmount };
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(p))}`
    ];
    return this.http.post('/api/org/setPlan', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  redeemCoupon(code) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `code=${encodeURIComponent(code)}`
    ];
    return this.http.post('/api/coupon/redeem', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
